import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';

import { IonicModule } from '@ionic/angular';
import { ReportsService } from '../reports/reports.service';
import { FiltersModalModule } from '../shared/modals/filters/filters.module';
import { ProcessUserListModalModule } from '../shared/modals/process-user-list/process-user-list.module';
import { PipesModule } from '../shared/pipes/pipes.module';
import { CycleComponent } from './cycle/cycle.component';
import { CycleProgressChartComponent } from './cycle/progress-chart/progress-chart.component';

import { PerformanceCyclesPage } from './performance-cycles.page';
import { PerformanceCycleService } from './performance-cycles.service';
import {
    ConfirmCloseStepModalComponent
} from "src/app/performance-cycles/cycle/confirm-close-step-modal/confirm-close-step-modal.component";
import { SelectCycleModule } from '../shared/modals/select-cycle/select-cycle.module';

const routes: Routes = [{
    path: '',
    component: PerformanceCyclesPage
}];

@NgModule({ imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        ProcessUserListModalModule,
        FiltersModalModule,
        SelectCycleModule
    ], declarations: [
        PerformanceCyclesPage,
        CycleComponent,
        CycleProgressChartComponent,
        ConfirmCloseStepModalComponent
    ],
    providers: [
        PerformanceCycleService,
        ReportsService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA] })
export class PerformanceCyclesPageModule {
}
